
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gZfi6", function(module, exports) {

var $ddnoW = parcelRequire("ddnoW");


var $iQwJa = parcelRequire("iQwJa");

var $bGVJw = parcelRequire("bGVJw");

var $5h1mk = parcelRequire("5h1mk");

var $1RMKR = parcelRequire("1RMKR");


var $gOWly = parcelRequire("gOWly");


var $6StHo = parcelRequire("6StHo");


var $b7cYO = parcelRequire("b7cYO");


var $6l4K1 = parcelRequire("6l4K1");


var $d3gqW = parcelRequire("d3gqW");


var $RJe7a = parcelRequire("RJe7a");


var $6J69K = parcelRequire("6J69K");


var $cozmU = parcelRequire("cozmU");


var $8aG6j = parcelRequire("8aG6j");


var $jTNdj = parcelRequire("jTNdj");


var $k4HA2 = parcelRequire("k4HA2");


var $82Ab4 = parcelRequire("82Ab4");

//#region src/message-renderer-provider/index.tsx
const $e8db06da93032c1e$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $e8db06da93032c1e$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), waitForTrigger: waitForTrigger, configSetId: configSetId, journeyId: journeyId, journeyTriggerId: journeyTriggerId })=>{
    const subscriptionEnabled = (0, $gOWly.useSubscriptionConfig)().subscription?.enabled ?? false;
    /**
	* Type guard: messageContextMemo must match MessageContextData exactly.
	* If a field is missing or wrong type, the type annotation will catch it.
	*/ const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /* @__PURE__ */ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
            name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /* @__PURE__ */ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $cozmU.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            transactionAccountId: componentProps.transactionAccountId,
            analyticsDetails: {
                ...postOffice?.analyticsDetails,
                subscriptionEnabled: subscriptionEnabled
            },
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps.transactionAccountId,
        postOffice?.analyticsDetails,
        subscriptionEnabled,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $6l4K1.MaybeChoreographerWrapper), {
        ChoreographerWrapper: $b7cYO.ChoreographerWrapper,
        enabled: !waitForTrigger,
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $d3gqW.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
                value: messageContextMemo,
                children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                    value: recommendationSession ?? $e8db06da93032c1e$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /* @__PURE__ */ (0, $8aG6j.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $RJe7a.MaybeTriggeredMessageValidator), {
                            waitForTrigger: waitForTrigger,
                            children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $6StHo.MessageAnalyticsContextProvider), {
                                children: /* @__PURE__ */ (0, $8aG6j.jsxs)((0, $6J69K.MaybeManualMessageViewedEvent), {
                                    isManual: !!waitForTrigger,
                                    children: [
                                        !waitForTrigger && messageSuccessComponent,
                                        children
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
 //# sourceMappingURL=message-renderer-provider.mjs.map



var $6MYaw = parcelRequire("6MYaw");


var $2WXqg = parcelRequire("2WXqg");


var $1p8wq = parcelRequire("1p8wq");





var $i3S9F = parcelRequire("i3S9F");


var $k2UaY = parcelRequire("k2UaY");


var $40SXV = parcelRequire("40SXV");




//#region src/create-placement/create-placement-component/index.tsx
const $756d79b0481f1912$var$ERROR_BOUNDARY_LOCATION = "create-placement-component";
const $756d79b0481f1912$var$createBasePlacementComponentV2 = (placementId, Component, options)=>(0, $40SXV.withErrorBoundary)((0, $cozmU.memo)((props)=>{
        const providedContext = (0, $bGVJw.usePostOfficeContext)();
        const route = (0, $5h1mk.usePostOfficeRoute)();
        const stableContext = (0, $1RMKR.useStableObject)(props?.context ?? providedContext);
        if (options?.hideInIsolatedCloud && typeof document !== "undefined" && (0, $i3S9F.isIsolatedCloud)()) return null;
        const { onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const context = props?.context ?? providedContext;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        return /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k2UaY.r), {
            placementId: placementId,
            children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k2UaY.n), {
                initialData: initialData,
                onEvent: onEvent,
                children: /* @__PURE__ */ (0, $8aG6j.jsx)((0, $k2UaY.t), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: options?.choreographer,
                    subscription: options?.subscription,
                    subscriptionAdapter: options?.subscriptionAdapter,
                    children: /* @__PURE__ */ (0, $8aG6j.jsx)(Component, {
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    }));
const $756d79b0481f1912$var$createPlacementComponentV2 = (placementId, Component, options)=>{
    const placement = $756d79b0481f1912$var$createBasePlacementComponentV2(placementId, Component, options);
    return (0, $cozmU.memo)((props)=>{
        return placement({
            ...props,
            errorBoundaryLocation: $756d79b0481f1912$var$ERROR_BOUNDARY_LOCATION,
            placementId: placementId,
            fallbackRender: ()=>null
        });
    });
};
//#endregion
//#region src/frontend/error.ts
var $756d79b0481f1912$var$PlacementMessageError = class extends Error {
    constructor(params){
        super(params.message ?? params.error?.message ?? "unknown placement message error"), (0, $ddnoW._)(this, "placementId", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "stageName", void 0), (0, $ddnoW._)(this, "placementLevel", void 0);
        this.name = params.error?.name ?? "PlacementMessageError";
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
};
const $756d79b0481f1912$var$createPlacementMessageError = (error)=>{
    if (error instanceof $756d79b0481f1912$var$PlacementMessageError) return error;
    if (error instanceof Error) return new $756d79b0481f1912$var$PlacementMessageError({
        error: error
    });
    return new $756d79b0481f1912$var$PlacementMessageError({});
};
//#endregion
//#region src/frontend/create-placement-frontend.tsx
const $756d79b0481f1912$export$7ccc53e8f1e7dfc5 = (placementConfig)=>(placementRenderer)=>({
            createFrontendStage: (stage)=>stage,
            createMessageFrontend: (stage)=>(config)=>[
                        config.messageTemplateId,
                        stage
                    ],
            createPlacementFrontendComponent: (config)=>{
                const messageTemplateRouter = $756d79b0481f1912$var$createFrontendPlacementMessageTemplateRouter({
                    ...placementConfig,
                    ...config
                });
                return $756d79b0481f1912$var$createPlacementComponentV2(placementConfig.placementId, placementRenderer(messageTemplateRouter), placementConfig.options);
            }
        });
const $756d79b0481f1912$var$createFrontendPlacementMessageRunner = ({ messageTemplates: messageTemplates, ...config })=>({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCategory: messageCategory, children: children, ...props })=>{
        const renderableStage = messageTemplates?.[messageTemplateId];
        const isHeadless = config.headlessMessageTemplateIds?.includes(messageTemplateId);
        const placementLocation = {
            messageTemplateId: messageTemplateId,
            messageInstanceId: messageInstanceId,
            placementLevel: "Message",
            stageName: config?.stageName,
            placementId: config.placementId
        };
        (0, $cozmU.useEffect)(()=>{
            if (isHeadless && renderableStage) console.error(new $756d79b0481f1912$var$PlacementMessageError({
                ...placementLocation,
                ...config
            }), "Misconfiguration: message is registered as both headless and has a MessageFrontend renderer. Remove it from headlessMessageTemplateIds or remove the MessageFrontend export.");
            if (!isHeadless && !renderableStage) console.error(new $756d79b0481f1912$var$PlacementMessageError({
                ...placementLocation,
                ...config
            }), "Misconfiguration: message is not registered as headless but has no MessageFrontend renderer. Register it as a headless message by reinstalling or add a MessageFrontend export.");
        }, [
            isHeadless,
            placementLocation,
            renderableStage,
            config
        ]);
        const componentPropsStable = (0, $1RMKR.useStableObject)(props);
        const messageProps = props;
        const triggerType = messageProps.triggerType ?? messageProps.context?.triggerType;
        const hasTrigger = (0, $1p8wq.isClientTriggeredMessage)(triggerType);
        const { waitForTrigger: waitForTrigger } = (0, $2WXqg.useWaitForTrigger)({
            hasTrigger: hasTrigger,
            messageSuccessComponent: void 0,
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
        if (!renderableStage) return null;
        try {
            renderableStage.validate({
                messageTemplateId: messageTemplateId,
                children: children,
                ...props
            });
            const { Component: Component } = renderableStage;
            return /* @__PURE__ */ (0, $8aG6j.jsxs)((0, $e8db06da93032c1e$export$5fe06fe68913d493), {
                ...componentPropsStable,
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCategory: messageCategory,
                isUFOEnabled: false,
                componentProps: componentPropsStable,
                waitForTrigger: waitForTrigger,
                children: [
                    !waitForTrigger && /* @__PURE__ */ (0, $8aG6j.jsx)((0, $6MYaw.MessageViewed), {}),
                    /* @__PURE__ */ (0, $8aG6j.jsx)(Component, {
                        ...props,
                        waitForTrigger: waitForTrigger,
                        children: children
                    })
                ]
            });
        } catch (error) {
            console.error($756d79b0481f1912$var$createPlacementMessageError(error));
            return null;
        }
    };
const $756d79b0481f1912$var$createFrontendPlacementMessageTemplateRouter = (config)=>{
    const messageTemplateLookup = $756d79b0481f1912$var$createMessageTemplateByStageLookup(config);
    return Object.entries(messageTemplateLookup).reduce((base, [stageName, messageTemplates])=>({
            ...base,
            [stageName]: $756d79b0481f1912$var$createFrontendPlacementMessageRunner({
                messageTemplates: messageTemplates,
                stageName: stageName,
                placementId: config.placementId,
                headlessMessageTemplateIds: config.headlessMessageTemplateIds
            })
        }), {});
};
const $756d79b0481f1912$var$createMessageTemplateByStageLookup = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stage])=>{
        Object.entries(stage).forEach(([stageName, stageExecutable])=>{
            if (!result[stageName]) result[stageName] = {};
            result[stageName][messageTemplateId] = stageExecutable;
        });
    });
    return result;
};
//#endregion
//#region src/frontend/create-headless-message-frontend.ts
/**
* Creates a placeholder frontend entry for a headless message installed in a backend+frontend placement.
*
* A headless message provides only a MessageBackend — its rendering is handled in-product by the
* consuming team (e.g. via usePlacementData). This factory creates a no-op FrontendPlacementMessage
* so the message template ID is still registered in messageFrontends and the placement can track it
* via headlessMessageTemplateIds.
*
* Usage in a generated placement file:
*   import { createHeadlessMessageFrontend } from '@post-office/placement-common-v2/frontend';
*   const messageFrontends = [
*     createMessageFrontendMyMessage({ messageTemplateId: 'my-message' }),
*     createHeadlessMessageFrontend({ messageTemplateId: 'headless-msg' }),
*   ];
*/ const $756d79b0481f1912$export$625550452a3fa3ec = ({ messageTemplateId: messageTemplateId })=>[
        messageTemplateId,
        {}
    ];
 //# sourceMappingURL=create-headless-message-frontend-BUHtXReF.mjs.map



var $B9QgK = parcelRequire("B9QgK");



//#region src/create-placement/index.tsx
/**
* @deprecated Import environment-specific APIs from /frontend or /backend instead.
*/ const $c5de345048f9b341$export$a2cfeb566a0f6574 = (placementConfig)=>{
    return {
        createFrontend: (0, $756d79b0481f1912$export$7ccc53e8f1e7dfc5)(placementConfig),
        createBackend: (0, $B9QgK.i)(placementConfig)
    };
};
 //# sourceMappingURL=index.mjs.map
module.exports["createPlacement"] = $c5de345048f9b341$export$a2cfeb566a0f6574;

});

parcelRegister("B9QgK", function(module, exports) {
//#region src/stages/placement/backend/index.ts
const $4d2220aefc63aef8$var$maybe = (stage)=>async (params)=>{
        return stage?.(params) ?? params.data;
    };
const $4d2220aefc63aef8$var$mergeMetadata = (fn)=>{
    const applyMerge = (target, source)=>{
        {
            const sourceMap = Object.fromEntries(source.messages.map((message)=>[
                    message.messageInstanceId,
                    message
                ]));
            return {
                messages: target.data.messages.map((message)=>fn(message, sourceMap?.[message.messageInstanceId]?.context))
            };
        }
    };
    return applyMerge;
};
const $4d2220aefc63aef8$export$43caf9889c228507 = {
    maybe: /**
	* The `maybe` function creates a passthrough stage,
	* which applies no changes, for cases where a stage might be undefined.
	*/ $4d2220aefc63aef8$var$maybe,
    mergeMetadata: /**
	* the `mergeMetadata` function is used when the result of a stage is
	* used to modify the message payload outside the message context
	*/ $4d2220aefc63aef8$var$mergeMetadata
};
//#endregion
//#region src/stages/placement/backend/hydrate/index.ts
const $4d2220aefc63aef8$var$applyHydrate = (hydrate)=>$4d2220aefc63aef8$export$43caf9889c228507.maybe(hydrate);
//#endregion
//#region src/stages/placement/backend/transform-metadata/index.ts
const $4d2220aefc63aef8$var$applyTransformMetadata = (transformMetadata)=>async (params)=>{
        const transformedMetadata = await $4d2220aefc63aef8$export$43caf9889c228507.maybe(transformMetadata)(params);
        const placementId = params?.request?.orchestrationContext?.placementId ?? "no-placement-found";
        return $4d2220aefc63aef8$export$43caf9889c228507.mergeMetadata((original, metadata)=>({
                ...original,
                enrichedAttributes: {
                    "in-app": {
                        [placementId]: metadata
                    }
                }
            }))(params, transformedMetadata);
    };
//#endregion
//#region src/stages/placement/backend/default/index.ts
const $4d2220aefc63aef8$export$7ccc53e8f1e7dfc5 = ({ transformMetadata: transformMetadata, hydrate: hydrate })=>({
        init: $4d2220aefc63aef8$var$applyTransformMetadata(transformMetadata),
        postInit: $4d2220aefc63aef8$var$applyHydrate(hydrate)
    });
//#endregion
//#region src/stages/placement-message/backend/transform-metadata/default/index.ts
const $4d2220aefc63aef8$export$625550452a3fa3ec = ()=>({
        goalMetadata: {
            primaryGoal: {
                goalId: "clickthrough"
            }
        }
    });
 //# sourceMappingURL=default-DtsLWxhL.mjs.map



var $fs98n = parcelRequire("fs98n");


var $ddnoW = parcelRequire("ddnoW");

//#region src/index.ts



let $1ade668d0d5c8b14$export$b9722560029694e7 = /* @__PURE__ */ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["ConfigSetNotFoundError"] = "ConfigSetNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["RetryableAtlassianMailError"] = "RetryableAtlassianMailError";
    PostOfficeErrorCodes["RetryableMobileNotificationsError"] = "RetryableMobileNotificationsError";
    PostOfficeErrorCodes["RecipientExpanderError"] = "RecipientExpanderError";
    PostOfficeErrorCodes["RetryableTCSError"] = "RetryableTCSError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    PostOfficeErrorCodes["MessageTemplatePackageMalformedError"] = "MessageTemplatePackageMalformedError";
    PostOfficeErrorCodes["EmptyMessageTemplateRegistryError"] = "EmptyMessageTemplateRegistryError";
    PostOfficeErrorCodes["PostOfficeGraphQLError"] = "PostOfficeGraphQLError";
    PostOfficeErrorCodes["NotificationRollupConflictError"] = "NotificationRollupConflictError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingDisabledError"] = "TesseractTemplateRuntimeMappingDisabledError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingValidationError"] = "TesseractTemplateRuntimeMappingValidationError";
    return PostOfficeErrorCodes;
}({});
var $1ade668d0d5c8b14$export$46f86d28cd0a5d38 = class extends Error {
};
var $1ade668d0d5c8b14$export$627bc00a5ef5f6ae = class extends Error {
};
/**
* @deprecated Do not use this pattern. Throwing errors from `hydrate()` to control message
* visibility is an anti-pattern that conflates hydration with filtering.
*
* **Why this is wrong:**
* Filtering decisions (e.g. experiment cohort checks, feature flag gates) belong in the
* filtering/eligibility stage, not inside `hydrate()`. Using errors as control flow here
* risks spreading a pattern that is difficult to reason about, harms observability, and
* fires experiment exposures at the wrong layer.
*
* **What to do instead:**
* - Use **message template filters** to gate visibility based on experiment or feature flag state.
* - For experiment exposure specifically, fire exposures on the Placement Frontend
*   (Narrow-Level Triggering) as described in the official guidance:
*   https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/5372727565/Where+to+fire+exposure+for+experiments+in+Post+Office
* - The long-term platform solution for narrow exposure is tracked in POST-773.
*
* This class will be removed once all existing usages have been migrated.
*/ var $1ade668d0d5c8b14$export$66e065cfeb491a4d = class HydrationAbortError extends $1ade668d0d5c8b14$export$46f86d28cd0a5d38 {
    static is(value) {
        return value instanceof HydrationAbortError;
    }
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$d145ea5319863172 = class extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), (0, $ddnoW._)(this, "code", void 0);
        this.code = code;
    }
};
var $1ade668d0d5c8b14$export$69be53c018c89481 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, details){
        super(message, "PostOfficeGraphQLError"), (0, $ddnoW._)(this, "clientName", void 0), (0, $ddnoW._)(this, "operationName", void 0), (0, $ddnoW._)(this, "status", void 0), (0, $ddnoW._)(this, "graphQLErrorMessage", void 0), (0, $ddnoW._)(this, "errors", void 0), (0, $ddnoW._)(this, "sanitisedRequestHeaders", void 0), (0, $ddnoW._)(this, "sanitisedResponseHeaders", void 0), (0, $ddnoW._)(this, "responseBody", void 0);
        this.name = this.constructor.name;
        this.clientName = details.clientName;
        this.operationName = details.operationName;
        this.status = details.status;
        this.graphQLErrorMessage = details.graphQLErrorMessage;
        this.errors = details.errors;
        this.sanitisedRequestHeaders = details.sanitisedRequestHeaders;
        this.sanitisedResponseHeaders = details.sanitisedResponseHeaders;
        this.responseBody = details.responseBody;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$6452976adc01572 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(cause, code){
        super($1ade668d0d5c8b14$var$getErrorMessage(cause), code, cause);
        this.name = this.constructor.name;
    }
};
const $1ade668d0d5c8b14$var$getErrorMessage = (cause)=>{
    if (cause instanceof Error) return cause.message;
    if (typeof cause === "string") return cause;
    return "Unknown error";
};
function $1ade668d0d5c8b14$export$4cb1ea6034a33155(error) {
    return typeof error === "object" && !!error && "status" in error && typeof error.status === "number";
}
function $1ade668d0d5c8b14$export$aed524b0009b5631(error) {
    return typeof error === "object" && !!error && "logLevel" in error && typeof error.logLevel === "string";
}
var $1ade668d0d5c8b14$export$ed601cd0dc1a1be7 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(args){
        /**
		* It is expected that this error message can be not deterministic.
		* This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		* Showing the error cause helps them understand what was the problem with their payload.
		*
		* On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		* to distinguish between message makers code errors and platform errors,
		* but we don't rely on the error message itself.
		*/ const errMessage = args.cause instanceof Error ? args.cause.message : "Error in message template code";
        super(errMessage, "MessageTemplateError", args.cause), (0, $ddnoW._)(this, "function", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "triggerId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$2833d4759f81601b = class extends $1ade668d0d5c8b14$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = "Invalid CSS property could not be processed by Juice";
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$8d39b103586e9fd4 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$f649da38897d27f7 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$c2852c1c4d9aba3e = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$4b7b4e09547e4bb3 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$360a094a97597d87 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$4d068b43eb55165b = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$ac007ee150add337 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$19cb89dd679394cb = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$78651662ad470cc5 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Message Template not found", "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$43b3b4535703ed1b = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            configSetId: this.configSetId
        };
    }
    constructor(configSetId){
        super(`Config Set with ConfigSetId ${configSetId} could not be found`, "ConfigSetNotFoundError"), (0, $ddnoW._)(this, "configSetId", void 0);
        this.configSetId = configSetId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$8a5041670cdd8db2 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(journeyId){
        super("Journey not found", "JourneyNotFoundError"), (0, $ddnoW._)(this, "journeyId", void 0);
        this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$1240ddc25cf964e6 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Message Template action handler validation error", "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$3c4884b7ae7fe517 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$913b8e68dc7ae8fe = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Placement not found", "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$3dfc27a8d3942f4d = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Message Renderer received empty response from validator", "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$e5ccdf8bbfead7a2 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$823733742d803ae6 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$1caa32527f23acd2 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(errorCause){
        super("Failed to send digest event to orchestration queue", "DigestEngineFailedSendError"), (0, $ddnoW._)(this, "errorCause", void 0);
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$a6f2aad8fa094b39 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Unable to get user details for the given account ID", "UnableToGetUserDetailsError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$2296e5dc6a1bf3d2 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Gateway timeout occurred", "GatewayTimeoutError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$2f1e27130c2bf271 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError"), (0, $ddnoW._)(this, "payloadSize", void 0);
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$d0dc094613469f2b = class extends $1ade668d0d5c8b14$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message), (0, $ddnoW._)(this, "workspaceId", void 0);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$5603eab37ce562f5 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(fileType){
        super("The attachment file is not supported", "UnsupportedAttachmentType"), (0, $ddnoW._)(this, "fileType", void 0);
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$e0e9aa0e9c6b37ff = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader"), (0, $ddnoW._)(this, "error", void 0);
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$3ad818f64601e141 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$25470bb6cba4fba0 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super("messageTemplateId not supported by placement", "UnsupportedMessageAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$ce14d445679448b6 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? "unknown error", "HydrationFailureAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
};
var $1ade668d0d5c8b14$export$c9a26a17db1045c8 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super("All messages failed at placement", "AllMessagesFailureHydrationAtPlacementError"), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$8ab4fb362168b928 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Unexpected invocation of validate() function for push delivery channel", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$2afd69f57fe5285f = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Recipient expander not found for mapper", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$7635d2b1a281d626 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError"), (0, $ddnoW._)(this, "errors", void 0);
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$9e1c6d00e675bc86 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError"), (0, $ddnoW._)(this, "recipient", void 0);
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$90bef7fa95eca3fa = class extends Error {
    constructor(status){
        super("Posting Mobile Notifications message failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$6d1a4929f6ff1a32 = class extends $1ade668d0d5c8b14$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$c19fc5e8aa4e064d = class extends Error {
    constructor(){
        super("Ingestion source is required when custom profile is specified");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$2d3a68dab93b8cc4 = class extends Error {
    constructor(){
        super("A renderRedacted function is required when redactionLevel is set to a non-null value");
        this.name = this.constructor.name;
    }
};
var $1ade668d0d5c8b14$export$175c1dbb0d7c238a = class extends Error {
    constructor(status){
        super("Enqueueing email failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$23fab744b3076342 = class extends Error {
    constructor(message, status){
        super(message), (0, $ddnoW._)(this, "message", void 0), (0, $ddnoW._)(this, "status", void 0);
        this.message = message;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$194adecfa0265ea1 = class extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg), (0, $ddnoW._)(this, "msg", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
};
var $1ade668d0d5c8b14$export$c504492f06c975b5 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super("hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user", "HydrationDeliveryNoDataFoundError"), (0, $ddnoW._)(this, "ipmNumber", void 0), (0, $ddnoW._)(this, "variantFromStatsig", void 0), (0, $ddnoW._)(this, "contentfulLocale", void 0);
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Error thrown when an upstream service (e.g., Atlassian Mail, Mobile Notifications, TCS)
* returns a retryable error status code (e.g. 500, 502, 503, 504).
*
* An SQS message that encounters this error will be retried.
*
* Only the final retry will be counted against our reliability SLOs and canary analysis.
*/ var $1ade668d0d5c8b14$export$1c932b9d1680ee0b = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(message, code, cause){
        super(message, code, cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$5d5d1885c87ef4bc = class extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Wraps an error thrown while running a recipient expander. Carries the expander key and message
* template id so they can be surfaced in logs and used to emit the recipient expander SLO metric.
*
* Co-located here with {@link UnretryableError} so a dedicated serializer can live in
* `@post-office/error-serializers` (the expander-specific fields are otherwise dropped by the
* generic error serializer).
*/ var $1ade668d0d5c8b14$export$85497ede72633b85 = class extends $1ade668d0d5c8b14$export$1c932b9d1680ee0b {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Recipient Expander Error: ${message}`, "RecipientExpanderError", error), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Unretryable variant of {@link RecipientExpanderError}, thrown when an expander fails with a
* non-retryable error. The originating error is preserved as the `cause`.
*/ var $1ade668d0d5c8b14$export$359a331da49d1ec8 = class extends $1ade668d0d5c8b14$export$5d5d1885c87ef4bc {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Unretryable Recipient Expander Error: ${message}`, {
            cause: error
        }), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Thrown when a message template package loads but is missing one or more exports that every
* template is required to have. In production the bundler intermittently produces module
* namespaces with re-exported bindings missing, which is decided once per process and then
* permanent. Detection uses a sentinel export rather than an exhaustive check, so `missingFields`
* reports what was inspected, not every binding the bundler actually dropped.
*
* Callers must treat this as a platform failure and let the message retry onto a healthy process;
* never as "the template has no subscriptions/config", which silently discards traffic.
*/ var $1ade668d0d5c8b14$export$8506e646874f88f6 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            missingFields: this.missingFields.join(",")
        };
    }
    constructor(messageTemplateId, missingFields){
        super("Message template package loaded without required exports", "MessageTemplatePackageMalformedError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "missingFields", void 0);
        this.messageTemplateId = messageTemplateId;
        this.missingFields = missingFields;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Thrown when the message template registry reports zero templates. There is no legitimate state in
* which Post Office has no templates, so callers must retry rather than read it as "nobody is
* subscribed"; the latter acks the message and discards it permanently.
*/ var $1ade668d0d5c8b14$export$6a4077faeb1c609 = class extends $1ade668d0d5c8b14$export$d145ea5319863172 {
    constructor(){
        super("Message template registry returned no templates", "EmptyMessageTemplateRegistryError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $1ade668d0d5c8b14$export$c2cfe2317dcfcabb = class extends Error {
    get nonSensitiveFields() {
        return {
            deliveryChannel: this.deliveryChannel
        };
    }
    constructor(deliveryChannel){
        super("Duplicate message detected"), (0, $ddnoW._)(this, "deliveryChannel", void 0);
        this.deliveryChannel = deliveryChannel;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
const $1ade668d0d5c8b14$export$fec3468114498229 = (value)=>typeof value === "object" && value !== null && Object.values(value).every((field)=>field === void 0 || field === null || typeof field === "string" || typeof field === "number" || typeof field === "boolean");
 //# sourceMappingURL=index.mjs.map


var $eb8eb3b792f36778$var$_MissingPlacementIdError;
//#region src/create-placement/error/index.ts
/**
* Thrown when createPlacementBackend is called with an empty placementId.
* This prevents DefaultHeadlessPlacementBackend's internal factory from
* accidentally reaching production — it only exposes createMessageBackend
* and useDefaultMessageBackend. The production placement backend with the
* correct placementId is created at install time by the CLI.
*/ var $eb8eb3b792f36778$export$625550452a3fa3ec = ($eb8eb3b792f36778$var$_MissingPlacementIdError = class MissingPlacementIdError extends Error {
    constructor(){
        super(MissingPlacementIdError.message);
        this.name = "MissingPlacementIdError";
    }
}, (0, $ddnoW._)($eb8eb3b792f36778$var$_MissingPlacementIdError, "message", "createPlacementBackend requires a non-empty placementId. DefaultHeadlessPlacementBackend only provides createMessageBackend and useDefaultMessageBackend. The production placement (with the correct placementId) is created at install time by the CLI."), $eb8eb3b792f36778$var$_MissingPlacementIdError);
var $eb8eb3b792f36778$export$43caf9889c228507 = class extends (0, $1ade668d0d5c8b14$export$d145ea5319863172) {
    constructor(params){
        const message = params.message ?? params.error?.message ?? "unknown placement system error";
        const code = params.code ?? (0, $1ade668d0d5c8b14$export$b9722560029694e7).PlacementSystemError;
        super(message, code), (0, $ddnoW._)(this, "placementId", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "stageName", void 0), (0, $ddnoW._)(this, "placementLevel", void 0);
        this.name = params.error?.name ?? this.constructor.name;
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
};
var $eb8eb3b792f36778$export$7ccc53e8f1e7dfc5 = class extends $eb8eb3b792f36778$export$43caf9889c228507 {
    constructor(params){
        super({
            ...params,
            message: "unknown placement message error",
            code: (0, $1ade668d0d5c8b14$export$b9722560029694e7).PlacementMessageError
        });
    }
};
var $eb8eb3b792f36778$var$PlacementRuntimeError = class extends $eb8eb3b792f36778$export$43caf9889c228507 {
    constructor(params){
        super({
            ...params,
            message: "unknown placement runtime error",
            code: (0, $1ade668d0d5c8b14$export$b9722560029694e7).PlacementRuntimeError
        });
    }
};
var $eb8eb3b792f36778$var$PlacementMiddlewareError = class extends $eb8eb3b792f36778$export$43caf9889c228507 {
    constructor(params){
        super({
            ...params,
            message: "unknown placement middleware error",
            code: (0, $1ade668d0d5c8b14$export$b9722560029694e7).PlacementRuntimeError
        });
    }
};
const $eb8eb3b792f36778$var$createPlacementErrorFactory = (errorType)=>(error)=>{
        if (error instanceof errorType) return new errorType({
            ...error,
            error: error
        });
        if (error instanceof Error) return new errorType({
            error: error
        });
        return new errorType({});
    };
const $eb8eb3b792f36778$var$createPlacementMessageError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$export$43caf9889c228507);
const $eb8eb3b792f36778$export$407448d2b89b1813 = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementMessageError(error));
const $eb8eb3b792f36778$var$createPlacementError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$export$43caf9889c228507);
const $eb8eb3b792f36778$export$23f2a1d2818174ef = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementError(error));
const $eb8eb3b792f36778$var$createPlacementSystemError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$export$43caf9889c228507);
const $eb8eb3b792f36778$export$db3b6bfb95261072 = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementSystemError(error));
const $eb8eb3b792f36778$var$createPlacementRuntimeError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$var$PlacementRuntimeError);
const $eb8eb3b792f36778$export$2408f22a0fab9ae5 = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementRuntimeError(error));
const $eb8eb3b792f36778$var$createPlacementMiddlewareError = $eb8eb3b792f36778$var$createPlacementErrorFactory($eb8eb3b792f36778$var$PlacementMiddlewareError);
const $eb8eb3b792f36778$export$ae1af26003f05816 = (request)=>(error)=>$eb8eb3b792f36778$var$logPlacementError(request)($eb8eb3b792f36778$var$createPlacementMiddlewareError(error));
const $eb8eb3b792f36778$var$logPlacementError = (request)=>(error)=>{
        request.logger.error({
            message: error.message,
            cause: error.cause,
            name: error.name,
            stack: error.stack,
            placementLevel: error.placementLevel
        });
        return error;
    };
 //# sourceMappingURL=error-CMI1qsH_.mjs.map



var $cXtTj = parcelRequire("cXtTj");




//#region src/index.ts
const $27a4e02d03060067$export$6d7470db509fd15d = [
    "admin",
    "aha",
    "analytics",
    "atlas",
    "atlassianStudio",
    "billingConsole",
    "bitbucket",
    "cmdb",
    "confluence-highlight-issue-create",
    "confluence-highlight-issue-create-ai",
    "confluence-whiteboards",
    "confluence",
    "confluence.ondemand",
    "cssXp",
    "databricks",
    "drive",
    "github",
    "identity",
    "jira",
    "jira-product-discovery",
    "jira-servicedesk",
    "jira-servicedesk.ondemand",
    "loom",
    "marketing",
    "mercury",
    "miro",
    "onedrive",
    "opsgenie",
    "outlook-calendar",
    "partner-unified-xp",
    "pop3",
    "rovo",
    "rovo-extension",
    "rovoChat",
    "salesforce",
    "sharepoint",
    "slack",
    "statuspage",
    "townsquare",
    "trello",
    "universalCreate",
    "zendesk"
];
const $27a4e02d03060067$var$IN_APP_ALLOWED_PRODUCT_SET = new Set($27a4e02d03060067$export$6d7470db509fd15d);
const $27a4e02d03060067$export$8278f7055159c0ba = (product)=>$27a4e02d03060067$var$IN_APP_ALLOWED_PRODUCT_SET.has(product);
 //# sourceMappingURL=index.mjs.map


//#region src/metrics-with-contextual-tags/index.ts
/**
* Creates a Metrics middleware compatible object {@see @atlassian/metrics-interface}
* that enriches every method with contextual tags without modifying metrics name as opposed to
* using metrics.child(name, tags) method which prepends its name to every metric.
*
* @param metrics
* @param contextualTags
*/ function $d2295b448b0f646b$export$e455422cde52a061(metrics, contextualTags) {
    return {
        child (name, tags) {
            return metrics.child(name, {
                ...contextualTags,
                ...tags
            });
        },
        counter (name, tags) {
            return metrics.counter(name, {
                ...contextualTags,
                ...tags
            });
        },
        event (title, description) {
            return metrics.event(title, description);
        },
        gauge (name, tags) {
            return metrics.gauge(name, {
                ...contextualTags,
                ...tags
            });
        },
        histogram (name, buckets, tags) {
            return metrics.histogram(name, buckets, {
                ...contextualTags,
                ...tags
            });
        },
        set (name, tags) {
            return metrics.set(name, {
                ...contextualTags,
                ...tags
            });
        },
        timing (name, tags) {
            return metrics.timing(name, {
                ...contextualTags,
                ...tags
            });
        }
    };
}
//#endregion
//#region src/trace-id.ts
/**
* B3 trace IDs must be 16 or 32 hex characters; randomUUID() includes hyphens,
* so remove them to produce a valid 32-character trace ID.
*/ function $d2295b448b0f646b$export$eb139a1a52c68fda() {
    return globalThis.crypto.randomUUID().replace(/-/g, "");
}
//#endregion
//#region src/metrics-product-normalizer/index.ts
const $d2295b448b0f646b$export$4b878dfc38059779 = [
    ...(0, $27a4e02d03060067$export$6d7470db509fd15d),
    "unknown"
];
const $d2295b448b0f646b$var$maxProductValueLength = $d2295b448b0f646b$export$4b878dfc38059779.reduce((max, value)=>Math.max(max, value.length), 0);
const $d2295b448b0f646b$var$sanitizedProductValuesSet = new Set($d2295b448b0f646b$export$4b878dfc38059779);
function $d2295b448b0f646b$export$ab03f5860d96b3e3(input, logger) {
    if (input.length > $d2295b448b0f646b$var$maxProductValueLength) {
        logger.warn({
            input: input
        }, "Product value is too long to be valid, returning unknown");
        return "unknown";
    }
    if ($d2295b448b0f646b$var$sanitizedProductValuesSet.has(input)) return input;
    const lowerCasedInput = input.toLowerCase();
    if ($d2295b448b0f646b$var$sanitizedProductValuesSet.has(lowerCasedInput)) return lowerCasedInput;
    logger.warn({
        input: input
    }, "Product value is not recognized, returning unknown");
    return "unknown";
}
//#endregion
//#region src/high-cardinality-metric-tag-overrides/index.ts
const $d2295b448b0f646b$var$DISABLED_METRIC_TAG_VALUE = "disabled";
const $d2295b448b0f646b$export$e924d1234600a844 = Object.freeze(Object.fromEntries([
    "deployment_id",
    "micros_service_version",
    "region",
    "micros_zone",
    "obs_sfx_enable",
    "container_name"
].map((tagName)=>[
        tagName,
        $d2295b448b0f646b$var$DISABLED_METRIC_TAG_VALUE
    ])));
 //# sourceMappingURL=index.mjs.map


//#region src/message-performance.ts
const $eeedeb00cf693440$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT = "message-performance.pull.per-placement";
const $eeedeb00cf693440$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE = "message-performance.push.per-recipient-type";
const $eeedeb00cf693440$var$HISTOGRAM_BUCKETS = {
    pull: {
        perStage: [
            10,
            25,
            50,
            100,
            150,
            200,
            250,
            300,
            400,
            500
        ],
        endToEnd: [
            25,
            100,
            200,
            300,
            400,
            500
        ]
    },
    push: {
        perStage: [
            100,
            500,
            1e3
        ],
        endToEnd: [
            100,
            500,
            1e3,
            5e3
        ]
    }
};
const $eeedeb00cf693440$var$defaultOptions = {
    logThreshold: 500,
    trackEndToEnd: false
};
/**
* Tracks performance for message processing.
*
* Responsibilities:
* 1) Measure each operation and emit timer + histogram metrics.
* 2) Keep a per message template id per layer cumulative timer -
* 	how much time was spend running all stages of message maker's code for a given message VS how much time was spend running Post Office orchestration code.
* 3) Optionally track end-to-end timing and emit logs if the total execution time exceeds a specified threshold.
*
* Public API is intentionally small:
* - `measureOperation`: wraps one async operation.
* - `stop`: flushes cumulative layer timings and final logging/metrics.
*/ var $eeedeb00cf693440$export$f5bd5a7a850da66e = class {
    /**
	* Wraps one async operation with timing instrumentation.
	*
	* Flow:
	* 1) Start stage metrics (timer + histogram).
	* 2) Execute callback.
	* 3) Record layer + longest-stage bookkeeping.
	* 4) Stop stage metrics with success/failure status.
	*/ async measureOperation(callback, tags, context) {
        const operationStart = performance.now();
        const stageMetricName = this.getMetricName(tags.stage);
        const histogramBuckets = $eeedeb00cf693440$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].perStage;
        const histogram = this.observability.metrics.histogram(stageMetricName, histogramBuckets).measure();
        const timer = this.observability.metrics.timing(stageMetricName).measure();
        let status = "success";
        try {
            return await callback();
        } catch (error) {
            status = "failure";
            throw error;
        } finally{
            const operationEndTime = performance.now();
            const operationLatency = operationEndTime - operationStart;
            this.recordOperationIntervalPerLayerPerMessage(tags.messageTemplateId, context.layer, operationStart, operationEndTime);
            this.updateSlowestOperationPerStagePerMessage(tags, context.layer, operationLatency);
            const operationMetricTags = this.applyTagOverrides({
                ...tags,
                status: status
            });
            histogram.stop(operationMetricTags);
            timer.stop(operationMetricTags);
        }
    }
    /**
	* Finalizes recording for this instance.
	*
	* Always publishes per-layer cumulative timings.
	* If end-to-end is enabled, also stops e2e metrics and logs slow executions.
	*/ stop() {
        this.publishTotalLayerLatencyPerMessage();
        if (!this.options.trackEndToEnd) return;
        const totalTime = performance.now() - this.startTime;
        this.publishEndToEndFlowLatency(totalTime);
        this.logThresholdExceeded(totalTime);
    }
    logThresholdExceeded(totalTime) {
        const logThreshold = this.options.logThreshold ?? $eeedeb00cf693440$var$defaultOptions.logThreshold;
        if (totalTime > logThreshold && this.slowestOperationPerStagePerMessage.size > 0) {
            const operationSequence = Array.from(this.slowestOperationPerStagePerMessage.values());
            this.observability.logger.info({
                totalTime: totalTime,
                logThreshold: logThreshold,
                operationSequence: operationSequence
            }, "Message performance threshold exceeded");
        }
    }
    getMetricName(suffix) {
        return this.options.metricNameSegments.flow === "pull" ? `${$eeedeb00cf693440$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT}.${this.options.metricNameSegments.placementId}.${suffix}` : `${$eeedeb00cf693440$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE}.${this.options.metricNameSegments.recipientType}.${suffix}`;
    }
    applyTagOverrides(tags) {
        return {
            ...tags,
            ...(0, $d2295b448b0f646b$export$e924d1234600a844)
        };
    }
    recordOperationIntervalPerLayerPerMessage(messageTemplateId, layer, operationStartTimeMs, operationEndTimeMs) {
        const key = `${layer}:${messageTemplateId}`;
        const existingIntervals = this.operationIntervalsPerLayerPerMessage.get(key) ?? [];
        existingIntervals.push({
            startTimeMs: operationStartTimeMs,
            endTimeMs: operationEndTimeMs
        });
        this.operationIntervalsPerLayerPerMessage.set(key, existingIntervals);
    }
    calculateTotalDurationForLayers(intervals) {
        if (intervals.length === 0) return 0;
        const sortedIntervals = intervals.toSorted((firstInterval, secondInterval)=>{
            return firstInterval.startTimeMs - secondInterval.startTimeMs;
        });
        const mergedIntervals = [];
        for (const currentInterval of sortedIntervals){
            const lastMergedInterval = mergedIntervals[mergedIntervals.length - 1];
            if (!lastMergedInterval || currentInterval.startTimeMs > lastMergedInterval.endTimeMs) {
                mergedIntervals.push({
                    ...currentInterval
                });
                continue;
            }
            lastMergedInterval.endTimeMs = Math.max(lastMergedInterval.endTimeMs, currentInterval.endTimeMs);
        }
        return mergedIntervals.reduce((totalDuration, interval)=>totalDuration + (interval.endTimeMs - interval.startTimeMs), 0);
    }
    updateSlowestOperationPerStagePerMessage(tags, layer, durationMs) {
        const key = `${tags.stage}:${tags.messageTemplateId}`;
        const existing = this.slowestOperationPerStagePerMessage.get(key);
        if (!existing || durationMs > existing.timeMs) this.slowestOperationPerStagePerMessage.set(key, {
            messageTemplateId: tags.messageTemplateId,
            stage: tags.stage,
            timeMs: durationMs,
            layer: layer
        });
    }
    publishTotalLayerLatencyPerMessage() {
        for (const [layer, operationIntervals] of this.operationIntervalsPerLayerPerMessage){
            const [layerName, messageTemplateId] = layer.split(":");
            const metricName = this.getMetricName(layerName);
            const totalLayerDuration = this.calculateTotalDurationForLayers(operationIntervals);
            const buckets = $eeedeb00cf693440$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].endToEnd;
            const tags = this.applyTagOverrides({
                messageTemplateId: messageTemplateId
            });
            this.observability.metrics.timing(metricName, tags).set(totalLayerDuration);
            this.observability.metrics.histogram(metricName, buckets, tags).set(totalLayerDuration);
        }
    }
    publishEndToEndFlowLatency(totalTime) {
        const metricName = this.getMetricName("e2e");
        const buckets = $eeedeb00cf693440$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].endToEnd;
        const tags = this.applyTagOverrides({});
        this.observability.metrics.timing(metricName, tags).set(totalTime);
        this.observability.metrics.histogram(metricName, buckets, tags).set(totalTime);
    }
    constructor(observability, options){
        (0, $ddnoW._)(this, "observability", void 0);
        (0, $ddnoW._)(this, "options", void 0);
        (0, $ddnoW._)(this, "startTime", performance.now());
        (0, $ddnoW._)(this, "slowestOperationPerStagePerMessage", /* @__PURE__ */ new Map());
        (0, $ddnoW._)(this, "operationIntervalsPerLayerPerMessage", /* @__PURE__ */ new Map());
        this.observability = observability;
        this.options = options;
    }
};
 //# sourceMappingURL=index.mjs.map



//#region src/stages/placement-message/backend/default/index.ts
const $06fb173e15603c4d$var$defaultBackendPlacementMessageStages = {};
//#endregion
//#region src/create-placement/util/message-helpers/index.ts
const $06fb173e15603c4d$export$ae1af26003f05816 = ()=>({
        transformMetadata: {
            validate: $06fb173e15603c4d$export$2408f22a0fab9ae5(),
            stage: (0, $4d2220aefc63aef8$export$625550452a3fa3ec)
        }
    });
const $06fb173e15603c4d$export$2408f22a0fab9ae5 = (_valueWithType)=>(input)=>input;
//#endregion
//#region src/create-placement/util/observability/index.ts
const $06fb173e15603c4d$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS = [
    25,
    50,
    100,
    150,
    200,
    250,
    500,
    1e3
];
const $06fb173e15603c4d$var$timerName = "post-office.placement-v2.stage.execute";
const $06fb173e15603c4d$var$counterName = "post-office.placement-v2.stage.result";
const $06fb173e15603c4d$var$hasDelta = (tags)=>{
    if (!tags || typeof tags.delta !== "object" || tags.delta === null) return false;
    const delta = tags.delta;
    return typeof delta.number === "number" && delta.number !== 0;
};
const $06fb173e15603c4d$var$createTimedStage = ({ tag: tag } = {})=>(stage)=>async (params)=>{
            const startTime = performance.now();
            const { stop: stop } = params.request.metrics.histogram($06fb173e15603c4d$var$timerName, $06fb173e15603c4d$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS, (0, $d2295b448b0f646b$export$e924d1234600a844)).measure();
            const result = stage(params);
            let tags;
            try {
                const unwrappedResult = result instanceof Promise ? await result : result;
                try {
                    tags = tag?.({
                        input: params,
                        output: unwrappedResult
                    });
                } catch  {
                    params.request.logger.warn("Unable to apply tags to stage logs");
                }
                params.request.metrics.counter($06fb173e15603c4d$var$counterName, {
                    status: "success"
                }).incr();
                return unwrappedResult;
            } catch (error) {
                params.request.metrics.counter($06fb173e15603c4d$var$counterName, {
                    status: "error"
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                if (params.request.statsig.checkGate({
                    identifiers: {
                        tenantId: params.request.orchestrationContext.tenantId ?? ""
                    }
                }, "post-office_enable-unified-finish-logs") ? (tag !== void 0 ? $06fb173e15603c4d$var$hasDelta : ()=>false)(tags) : true) params.request.logger.info({
                    latencyInMs: latencyInMs,
                    ...tags
                }, "Finished stage");
            }
        };
const $06fb173e15603c4d$var$createTimedSystemStage = (fn)=>(contexts)=>{
        return async (params)=>{
            const startTime = performance.now();
            const { stop: stop } = contexts.request.metrics.histogram($06fb173e15603c4d$var$timerName, $06fb173e15603c4d$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS, (0, $d2295b448b0f646b$export$e924d1234600a844)).measure();
            const result = fn(contexts)(params);
            try {
                const unwrappedResult = await result;
                contexts.request.metrics.counter($06fb173e15603c4d$var$counterName, {
                    status: "success"
                }).incr();
                return unwrappedResult;
            } catch (error) {
                contexts.request.metrics.counter($06fb173e15603c4d$var$counterName, {
                    status: "error"
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                contexts.request.logger.info({
                    latencyInMs: latencyInMs
                }, "Finished stage");
            }
        };
    };
const $06fb173e15603c4d$var$messageTimedStage = $06fb173e15603c4d$var$createTimedStage({});
const $06fb173e15603c4d$var$placementTimedStage = $06fb173e15603c4d$var$createTimedStage({
    tag: ({ input: input, output: output })=>{
        if (!output) return {};
        const inputMessageTemplateIdsSet = new Set(input.data.messages.map((message)=>message.messageTemplateId));
        const inputMessageTemplateIds = Array.from(inputMessageTemplateIdsSet.values());
        const outputMessageTemplateIdsSet = new Set(output.messages.map((message)=>message.messageTemplateId));
        const outputMessageTemplateIds = Array.from(outputMessageTemplateIdsSet.values());
        const deltaMessageTemplateIds = inputMessageTemplateIds.filter((id)=>!outputMessageTemplateIdsSet.has(id));
        const inputMessageInstanceIds = input.data.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId);
        const outputMessageInstanceIdsSet = new Set(output.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId));
        const outputMessageInstanceIds = Array.from(outputMessageInstanceIdsSet.values());
        const deltaMessageInstanceIds = inputMessageInstanceIds.filter((id)=>!outputMessageInstanceIdsSet.has(id));
        return {
            input: {
                number: input.data.messages.length,
                messageTemplateIds: inputMessageTemplateIds,
                messageInstanceIds: inputMessageInstanceIds
            },
            output: {
                number: output.messages.length,
                messageTemplateIds: outputMessageTemplateIds,
                messageInstanceIds: outputMessageInstanceIds
            },
            delta: {
                number: output.messages.length - input.data.messages.length,
                messageTemplateIds: deltaMessageTemplateIds,
                messageInstanceIds: deltaMessageInstanceIds
            }
        };
    }
});
const $06fb173e15603c4d$var$placementRuntimeTimedStage = $06fb173e15603c4d$var$createTimedSystemStage;
const $06fb173e15603c4d$var$logRuntimeResult = ({ request: request })=>({ result: result, latencyInMs: latencyInMs })=>{
        const errorMessageTemplateIds = Array.from(new Set(result.errors.map((e)=>e.messageTemplateId)).values());
        const messageTemplateIds = Array.from(new Set(result.data.messages.map((e)=>e.messageTemplateId)).values());
        const formattedMessages = result.data.messages.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCreationType: messageCreationType, messageCategory: messageCategory, triggerId: triggerId })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCreationType: messageCreationType,
                messageCategory: messageCategory,
                triggerId: triggerId
            }));
        const formattedErrorDetails = result.errors.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, reason: reason })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                reason: reason
            }));
        request.logger.info({
            latencyInMs: latencyInMs,
            errors: {
                number: result.errors.length,
                messageTemplateIds: errorMessageTemplateIds,
                messageDetails: formattedErrorDetails
            },
            messages: {
                number: result.data.messages.length,
                messageTemplateIds: messageTemplateIds,
                messageDetails: formattedMessages
            }
        }, "Runtime result");
    };
//#endregion
//#region src/create-placement/backend-factory.ts
const $06fb173e15603c4d$export$407448d2b89b1813 = (stages)=>(messageBackendConfig)=>{
        const stagesWithDefaults = $06fb173e15603c4d$var$applyDefaultMessageBackendStages(stages);
        return [
            messageBackendConfig.messageTemplateId,
            stagesWithDefaults
        ];
    };
const $06fb173e15603c4d$export$23f2a1d2818174ef = (placementConfig)=>(placementBackendParams)=>({
            createBackendStage: (stage)=>stage,
            createMessageBackend: (stages)=>$06fb173e15603c4d$export$407448d2b89b1813(stages),
            createPlacementBackend: (placementBackendConfig)=>(runtime)=>{
                    const placementId = placementConfig.placementId;
                    if (!placementId) throw new (0, $eb8eb3b792f36778$export$625550452a3fa3ec)();
                    const placementBackendStages = placementBackendParams?.stages ?? (0, $4d2220aefc63aef8$export$7ccc53e8f1e7dfc5);
                    const placementStages = $06fb173e15603c4d$export$43caf9889c228507(placementBackendStages);
                    const messagesStages = $06fb173e15603c4d$export$7ccc53e8f1e7dfc5({
                        ...placementConfig,
                        ...placementBackendConfig
                    });
                    const statelessMiddleware = (placementBackendParams?.customMiddleware ?? (0, $fs98n.n))({
                        ...placementConfig,
                        ...placementBackendParams?.params
                    });
                    const statelessMessagesRuntime = runtime({
                        messagesStages: messagesStages,
                        placementStages: placementStages,
                        placementId: placementId
                    });
                    const withRequestMetadata = (ctx)=>{
                        if (ctx.header?.["x-include-request-metadata"] === "true") {
                            const state = ctx.state;
                            ctx.body.requestMetadata = {
                                ...describe(),
                                graph: (0, $cXtTj.default).checkGate("post_office_enable-visualization") ? state.requestContext.location.getGraph() : void 0
                            };
                        }
                    };
                    const buildPlacementContext = (ctx, next)=>{
                        const koa = {
                            ctx: ctx,
                            next: next
                        };
                        const request = ctx.state.requestContext.location.tag({
                            placementId: placementConfig.placementId
                        });
                        const messagesRuntime = async (config)=>{
                            const configuredRequest = (config?.request ?? request).location.tag({
                                placementLevel: "Runtime"
                            });
                            if (!configuredRequest) throw new (0, $eb8eb3b792f36778$export$43caf9889c228507)({
                                message: "request context not available at runtime call"
                            });
                            const contexts = {
                                koa: koa,
                                request: configuredRequest
                            };
                            const combinedParams = {
                                ...placementBackendParams?.params,
                                ...config?.params
                            };
                            try {
                                const runtimeStartTime = performance.now();
                                const result = await $06fb173e15603c4d$var$placementRuntimeTimedStage(statelessMessagesRuntime)(contexts)(combinedParams);
                                const runtimeLatencyInMs = performance.now() - runtimeStartTime;
                                $06fb173e15603c4d$var$logRuntimeResult(contexts)({
                                    result: result,
                                    latencyInMs: runtimeLatencyInMs
                                });
                                return result;
                            } catch (error) {
                                throw (0, $eb8eb3b792f36778$export$2408f22a0fab9ae5)(contexts.request)(error);
                            }
                        };
                        return {
                            koa: koa,
                            request: request,
                            postOffice: {
                                messagesRuntime: messagesRuntime
                            },
                            messagesRuntime: messagesRuntime
                        };
                    };
                    const koaMiddleware = async (ctx, next)=>{
                        const { koa: koa, request: request, postOffice: postOffice } = buildPlacementContext(ctx, next);
                        const middlewareRequest = request.location.tag({
                            placementLevel: "Middleware"
                        });
                        try {
                            await statelessMiddleware({
                                koa: koa,
                                postOffice: postOffice,
                                request: middlewareRequest,
                                placement: placementConfig
                            });
                        } catch (error) {
                            throw (0, $eb8eb3b792f36778$export$ae1af26003f05816)(request)(error);
                        } finally{
                            if ((0, $cXtTj.default).checkGate("post_office_enable-visualization")) middlewareRequest.location.stopTimer();
                            withRequestMetadata(ctx);
                        }
                    };
                    const dataMiddleware = async (ctx, next)=>{
                        const { request: request, messagesRuntime: messagesRuntime } = buildPlacementContext(ctx, next);
                        const middlewareRequest = request.location.tag({
                            placementLevel: "Middleware"
                        });
                        try {
                            ctx.body = await messagesRuntime({
                                request: middlewareRequest
                            });
                            ctx.status = 200;
                        } catch (error) {
                            throw (0, $eb8eb3b792f36778$export$ae1af26003f05816)(request)(error);
                        } finally{
                            if ((0, $cXtTj.default).checkGate("post_office_enable-visualization")) middlewareRequest.location.stopTimer();
                            withRequestMetadata(ctx);
                        }
                    };
                    const describe = ()=>{
                        const messageTemplates = placementBackendConfig.messageTemplates.map(([id, stages])=>{
                            return {
                                id: id,
                                stages: Object.keys(stages)
                            };
                        });
                        return {
                            placementId: placementConfig.placementId,
                            messageTemplates: messageTemplates
                        };
                    };
                    const standaloneRuntime = async (config)=>{
                        if (!config?.request) throw new (0, $eb8eb3b792f36778$export$43caf9889c228507)({
                            message: "request is required when calling runtime directly"
                        });
                        const request = config.request.location.tag({
                            placementId: placementConfig.placementId,
                            placementLevel: "Runtime"
                        });
                        const combinedParams = {
                            ...placementBackendParams?.params,
                            ...config?.params
                        };
                        try {
                            const runtimeStartTime = performance.now();
                            const result = await $06fb173e15603c4d$var$placementRuntimeTimedStage(statelessMessagesRuntime)({
                                request: request
                            })(combinedParams);
                            const runtimeLatencyInMs = performance.now() - runtimeStartTime;
                            $06fb173e15603c4d$var$logRuntimeResult({
                                request: request
                            })({
                                result: result,
                                latencyInMs: runtimeLatencyInMs
                            });
                            return result;
                        } catch (error) {
                            throw (0, $eb8eb3b792f36778$export$2408f22a0fab9ae5)(request)(error);
                        }
                    };
                    return {
                        middleware: koaMiddleware,
                        endpoints: {
                            renderer: koaMiddleware,
                            data: dataMiddleware
                        },
                        config: {
                            ...placementBackendConfig,
                            ...placementBackendParams,
                            ...placementConfig
                        },
                        describe: describe,
                        runtime: standaloneRuntime
                    };
                }
        });
const $06fb173e15603c4d$var$applyDefaultMessageBackendStages = (stages)=>{
    const validatedDefaultStages = {};
    Object.entries($06fb173e15603c4d$var$defaultBackendPlacementMessageStages).forEach(([stageName, stage])=>{
        validatedDefaultStages[stageName] = {
            validate: $06fb173e15603c4d$export$2408f22a0fab9ae5(),
            stage: stage
        };
    });
    return {
        ...validatedDefaultStages,
        ...stages()
    };
};
const $06fb173e15603c4d$export$43caf9889c228507 = (config)=>{
    return (placementMessageStages)=>{
        const placementStages = config(placementMessageStages);
        const wrappedPlacementStages = {};
        Object.entries(placementStages).forEach(([stageName, stage])=>{
            if (!stage) wrappedPlacementStages[stageName] = void 0;
            wrappedPlacementStages[stageName] = $06fb173e15603c4d$var$createBackendPlacementRunner({
                stageName: stageName,
                stage: stage
            });
        });
        return wrappedPlacementStages;
    };
};
const $06fb173e15603c4d$var$createBackendPlacementRunner = ({ stageName: stageName, stage: stage })=>async (params)=>{
        const request = params.request.location.tag({
            placementLevel: "Placement",
            stageName: stageName
        });
        if (!stage) return params.data;
        try {
            return await $06fb173e15603c4d$var$placementTimedStage(stage)({
                request: request,
                data: params.data
            });
        } catch (error) {
            throw (0, $eb8eb3b792f36778$export$23f2a1d2818174ef)(request)(error);
        }
    };
const $06fb173e15603c4d$export$7ccc53e8f1e7dfc5 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stages])=>Object.entries(stages).forEach(([stageName, stage])=>{
            if (!result[messageTemplateId]) result[messageTemplateId] = {};
            result[messageTemplateId][stageName] = $06fb173e15603c4d$var$createBackendPlacementMessageRunner({
                stage: stage,
                stageName: stageName,
                placementId: config.placementId
            });
        }));
    return result;
};
const $06fb173e15603c4d$var$createBackendPlacementMessageRunner = (config)=>{
    return async (input)=>{
        const { message: message } = input;
        const request = input.request.location.tag({
            placementLevel: "Message",
            messageTemplateId: message?.messageTemplateId,
            messageInstanceId: message?.messageInstanceId,
            triggerId: message?.triggerId,
            stageName: config?.stageName
        });
        try {
            const { validate: validate, stage: stage } = config.stage;
            validate(input.message.context);
            const hydratedContext = await (request.messagePerformance ?? new (0, $eeedeb00cf693440$export$f5bd5a7a850da66e)(request, {
                trackEndToEnd: false,
                metricNameSegments: {
                    flow: "pull",
                    placementId: config.placementId
                }
            })).measureOperation(async ()=>await $06fb173e15603c4d$var$messageTimedStage(stage)({
                    request: request,
                    message: message
                }), {
                messageTemplateId: message.messageTemplateId,
                operation: config.stageName,
                stage: "hydration"
            }, {
                layer: "message"
            });
            return {
                ...message,
                context: {
                    ...hydratedContext,
                    ...message.context.triggerType !== void 0 ? {
                        triggerType: message.context.triggerType
                    } : {}
                }
            };
        } catch (error) {
            throw (0, $eb8eb3b792f36778$export$407448d2b89b1813)(request)(error);
        }
    };
};
//#endregion
//#region src/backend/default-headless-placement-backend.ts
/**
* Type-safe factory helpers for message templates installed into backend-only placements.
*
* Use this when there is no real PlacementBackend to import from a placement-specific package.
* The actual placement (with the correct placement ID derived from the folder name) is created
* at install time via the CLI — this object only provides the message-level factory methods.
*/ const $06fb173e15603c4d$export$625550452a3fa3ec = {
    createMessageBackend: (stages)=>$06fb173e15603c4d$export$407448d2b89b1813(stages),
    withDefaultMessageBackend: ()=>$06fb173e15603c4d$export$407448d2b89b1813($06fb173e15603c4d$export$ae1af26003f05816)
};
 //# sourceMappingURL=default-headless-placement-backend-OZpln0Ee.mjs.map
module.exports["o"] = $06fb173e15603c4d$export$ae1af26003f05816;
module.exports["s"] = $06fb173e15603c4d$export$2408f22a0fab9ae5;
module.exports["i"] = $06fb173e15603c4d$export$23f2a1d2818174ef;

});

parcelRegister("fs98n", function(module, exports) {
//#region src/create-placement/util/flatten-messages-for-frontend/index.ts
const $b4008e6503a075c8$var$flattenMessageForFrontend = ({ context: context, ...message })=>({
        ...message,
        ...context
    });
/**
* By convention we flatten the response on the backend so we aren't so reliant on memoizing props on the frontend.
*/ const $b4008e6503a075c8$export$23f2a1d2818174ef = (messages)=>messages.map($b4008e6503a075c8$var$flattenMessageForFrontend);
//#endregion
//#region src/create-placement/default-placement-middleware/index.ts
const $b4008e6503a075c8$export$625550452a3fa3ec = (execute)=>(params)=>async ({ request: request, koa: koa, postOffice: postOffice, placement: placement })=>{
            try {
                const result = await execute({
                    request: request,
                    koa: koa,
                    postOffice: postOffice,
                    placement: placement,
                    params: params
                });
                koa.ctx.body = result;
                koa.ctx.status = 200;
            } catch (error) {
                request.logger.error({
                    error: error
                }, "placement middleware error");
                koa.ctx.status = 500;
                koa.ctx.body = {
                    message: "An error occurred"
                };
            }
        };
const $b4008e6503a075c8$export$7ccc53e8f1e7dfc5 = $b4008e6503a075c8$export$625550452a3fa3ec(async ({ postOffice: postOffice })=>{
    const result = await postOffice.messagesRuntime();
    $b4008e6503a075c8$export$43caf9889c228507(result);
    return {
        ...result.data,
        messages: $b4008e6503a075c8$export$23f2a1d2818174ef(result.data.messages)
    };
});
const $b4008e6503a075c8$export$43caf9889c228507 = ({ errors: errors, data: data })=>{
    const { messages: messages } = data;
    if (!(messages.length > 1)) return;
    const uniqueErrorIds = new Set(errors.map((e)=>e?.messageTemplateId ?? "unknown"));
    const uniqueMessageIds = new Set(messages.map((e)=>e.messageTemplateId));
    if (uniqueErrorIds.size > 1 && uniqueMessageIds.size / uniqueMessageIds.size > .1) throw new Error("too many message template errors");
};
 //# sourceMappingURL=default-placement-middleware-icHb-GfA.mjs.map
module.exports["i"] = $b4008e6503a075c8$export$23f2a1d2818174ef;
module.exports["t"] = $b4008e6503a075c8$export$625550452a3fa3ec;
module.exports["n"] = $b4008e6503a075c8$export$7ccc53e8f1e7dfc5;
module.exports["r"] = $b4008e6503a075c8$export$43caf9889c228507;

});

parcelRegister("f3m05", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $4fmou = parcelRequire("4fmou");

//#region src/create-placement/i18n/index.tsx
const $af5833a9d0e560cb$export$920091e3d72d80ee = (loaders)=>{
    const messagesLoader = $af5833a9d0e560cb$export$99ce90405b04bcbd(loaders);
    const I18n = ({ children: children })=>/* @__PURE__ */ (0, $8aG6j.jsx)((0, $4fmou.IntlProvider), {
            messagesLoader: messagesLoader,
            children: children
        });
    return ({ children: children })=>{
        return /* @__PURE__ */ (0, $8aG6j.jsx)(I18n, {
            children: children
        });
    };
};
const $af5833a9d0e560cb$export$d71c6502467fe725 = (...loaders)=>{
    const messagesLoader = $af5833a9d0e560cb$export$99ce90405b04bcbd(...loaders);
    return (component)=>{
        return (0, $4fmou.withIntlProvider)({
            messagesLoader: messagesLoader
        }, component);
    };
};
const $af5833a9d0e560cb$export$99ce90405b04bcbd = (...loaders)=>async (locale)=>{
        const messagePromises = loaders.filter((e)=>!!e).map((loader)=>loader(locale));
        const loadedMessages = await Promise.allSettled(messagePromises);
        const translatedMessages = {
            messages: {},
            errors: []
        };
        loadedMessages.forEach((result)=>{
            if (result.status === "rejected") {
                translatedMessages.errors.push(`Failed to load translations with ${result.reason}`);
                return;
            }
            translatedMessages.messages = {
                ...translatedMessages.messages,
                ...result.value
            };
        });
        return translatedMessages;
    };
 //# sourceMappingURL=i18n.mjs.map
module.exports["createWithI18n"] = $af5833a9d0e560cb$export$d71c6502467fe725;

});


//# sourceMappingURL=ShareAndRestrictDialog.6ca0d02c.js.map
